import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import LButton from '@/components/core/Button.vue'
import DeleteModal from '@/components/core/DeleteModal.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import DropdownMenuItem from '@/components/core/DropdownMenuItem.vue'
import { useDateTimePeriodFormat } from '@/composables/date'
import type { Rental } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'RentalListItem',
  props: {
    rental: null,
    mode: null,
    isLinked: { type: Boolean }
  },
  emits: ["link", "unlink", "edit", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'link'): void
  (e: 'unlink'): void
  (e: 'edit'): void
  (e: 'delete'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  rental: Rental
  mode: 'list' | 'selected'
  isLinked?: boolean
};





const dateString = useDateTimePeriodFormat(props.rental.period)

const isDropdownOpen = ref(false)

function handleDelete() {
  isDropdownOpen.value = false
  emit('delete')
}

return { __sfc: true,props, emit, dateString, isDropdownOpen, handleDelete, LButton, DeleteModal, DropdownMenu, DropdownMenuItem }
}

})